// JWT payload에서 필요한 클레임만 읽는다 — 서명 검증은 서버가 하므로 여기서는 하지 않는다(신뢰 판단 목적이
// 아니라 "언제 조용히 재발급을 시도할지" 타이머를 잡거나, 쿠키 사용자와 같은 사람인지 비교하는 용도일 뿐이다).
// AuthContext의 조용한 토큰 재발급(2026-09-22, 사용자 요청)이 exp를 근거로 만료 전에 미리 /auth/refresh를 호출한다.

/** base64(또는 base64url) 문자열을 UTF-8 텍스트로 디코드한다 — atob만 쓰면 한글이 깨진다(한글 아이디가 실재한다). */
export function decodeBase64Utf8(input: string): string {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
  const binary = atob(padded)
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
  return new TextDecoder('utf-8').decode(bytes)
}

/** JWT의 두 번째 세그먼트(payload)를 객체로 디코드한다. 형식이 이상하면 undefined. */
function decodeJwtPayload(token: string): Record<string, unknown> | undefined {
  try {
    const payload = token.split('.')[1]
    if (!payload) return undefined
    const json = JSON.parse(decodeBase64Utf8(payload)) as unknown
    return json && typeof json === 'object' ? (json as Record<string, unknown>) : undefined
  } catch {
    return undefined
  }
}

/** JWT의 `exp`(초 단위, UNIX epoch)를 밀리초로 돌려준다.
 *  형식이 이상하면(토큰이 아니거나 payload가 없거나 exp가 없으면) undefined. */
export function decodeJwtExpMs(token: string): number | undefined {
  const exp = decodeJwtPayload(token)?.exp
  return typeof exp === 'number' ? exp * 1000 : undefined
}

/** JWT의 `userId` 클레임(백엔드 EgovJwtTokenUtil이 넣는 로그인 아이디). 없으면 undefined. */
export function decodeJwtUserId(token: string): string | undefined {
  const userId = decodeJwtPayload(token)?.userId
  return typeof userId === 'string' && userId.trim() ? userId.trim() : undefined
}
